<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { ScanMode, ScanState, ScanTarget } from '@/models/Scan'
import CameraScanner from './CameraScanner.vue'
import ZebraScanner from './ZebraScanner.vue'

const props = defineProps({
  target: {
    type: String,
    default: ScanTarget.Container,
  },
  state: {
    type: String,
    default: ScanState.Scanning,
  },
})
defineEmits(['barcode-scanned'])

const userStore = useUserStore()
const user = userStore.authenticatedUser
</script>

<template>
  <div class="scanner">
    <ZebraScanner
      :target="props.target"
      :state="props.state"
      @barcode-scanned="$emit('barcode-scanned', $event)"
      v-if="user?.scanMode === ScanMode.Zebra"
    />
    <CameraScanner @barcode-scanned="$emit('barcode-scanned', $event)" v-else />
  </div>
</template>

<style scoped lang="scss">
.scanner {
  width: 100%;
  height: 35dvh;
}
</style>
